module.exports = __webpack_public_path__ + "img/web_19.40a3b54b.png";